module.exports = __webpack_public_path__ + "static/media/image_55.db85e567.png";